import React from 'react';
import * as PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Result, Icon } from 'antd';
import { FormattedMessage } from 'react-intl';
import DownloadApp from './DownloadApp';
import { configRoutes, documentationRoutes, entryRoutes } from '../../../../utility/route-locations';


export function NoInspectionsResult() {
  return (
    <Result
      icon={<Icon type="carry-out" theme="twoTone" />}
      title={<FormattedMessage id="widgetMessageTitle" />}
      style={{ padding: '0' }}
      extra={(
        <div style={{ marginTop: '-30px', fontWeight: 500 }}>
          <p style={{ fontSize: '1.1em', marginBottom: '0' }}><FormattedMessage id="widgetMessage1" /></p>
          <DownloadApp style={{ display: 'block', marginBottom: '0.5em' }} />
          <Link to={entryRoutes.configure} style={{ fontWeight: 'normal', display: 'block' }}><FormattedMessage id="customiseApplication" /></Link>
          <Link to={configRoutes.configure_users} style={{ fontWeight: 'normal', display: 'block' }}><FormattedMessage id="widgetMessage5" /></Link>
          <Link to={documentationRoutes.user_guide} style={{ fontWeight: 'normal', fontSize: 'smaller', display: 'block' }} target="_blank"><FormattedMessage id="widgetMessage6" /></Link>
        </div>
      )}
    />
  );
}

/**
 * Renders a widget with the NoInspections message overlayed.
 *
 * @param {object} props The react props
 * @param {object} props.children The underlying component to render.
 */
export default function NoInspections({ underlayComponent: UnderlayComponent }) {
  if (!UnderlayComponent) return <NoInspectionsResult />;

  return (
    // We need to wrap everything with 'position: relative' so that the overlay which is 'position: absolute' will position nicely.
    <div style={{ position: 'relative', width: '1000px', height: '1000px' }}>
      <UnderlayComponent />
      <div style={{
        position: 'absolute',
        top: '0',
        backgroundColor: 'rgba(255, 255, 255, 0.9)',
        zIndex: '10',
        height: '100%',
        width: '100%',
      }}
      >
        <NoInspectionsResult />
      </div>
    </div>
  );
}

NoInspections.propTypes = {
  underlayComponent: PropTypes.func,
};

NoInspections.defaultProps = {
  underlayComponent: null,
};
